const ENVS = {
  prod: '/',
  local: 'https://service.donsalomon.com/ds-service/public/api',
}

const ENV = ENVS.local

export { ENV }
